// extracted by mini-css-extract-plugin
export var deleteIcon = "_pw-5";
export var deleteOption = "_pw-3";
export var divider = "_pw-2";
export var downloadIcon = "_pw-4";
export var drawer = "_pw-0";
export var drawerFooter = "_pw-6";
export var drawerOpen = "_pw-1";
export var highlighted = "_pw-7";
export var lighterHighlight = "_pw-8";